<template>
  <div class="home">
  
    <Reproductor msg="Los sustantivos" audio2="../mp3/PrimariaE/03PE.mp3" cover="../img/5.jpg" name="Primaria E - Lección #3"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
